import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['source'];

  async copy() {
    try {
      await navigator.clipboard.writeText(this.sourceTarget.value);
    } catch {
      this.sourceTarget.focus();
      this.sourceTarget.select();
    }
  }
}
